<template>
    <div>
        <div class="bg-lightGray mt-3 rounded">
            <div class="card-body" v-if="$i18n.locale === 'ru'">
                <h5 class="card-title">{{ $t('advice') }}</h5>
                <div>
                    <div v-if="advices[0].isShowAdvice">
                        <p class="text">
                            Чтобы начать продажу, добавьте
                            <router-link :to="$i18nHelper.getUrl('products/add')">{{ $t('product.title') }}</router-link>
                            и купите продукт на странице
                            <router-link :to="$i18nHelper.getUrl('products/0/purchase')">{{
                                    $t('productPurchase.title')
                                }}.
                            </router-link>
                        </p>
                    </div>
                    <div v-if="advices[1].isShowAdvice">
                        <p class="text">
                            Для продажы продукта, перейдите на страницу
                            <router-link :to="$i18nHelper.getUrl('sales/add')">{{ $t('sale.title') }}.</router-link>
                        </p>
                    </div>
                    <div v-if="advices[2].isShowAdvice">
                        <p class="text">
                            Чтобы узнать баланс продуктов, перейдите на страницу
                            <router-link :to="$i18nHelper.getUrl('warehouses')">{{ $t('warehouse.title') }}.</router-link>
                        </p>
                    </div>
                    <div v-if="advices[3].isShowAdvice">
                        <p class="text">
                            Чтобы узнать активы компании, перейдите на страницу
                            <router-link :to="$i18nHelper.getUrl('company')">{{ $t('company.title') }}.</router-link>
                        </p>
                    </div>
                    <div v-if="advices[4].isShowAdvice">
                        <p class="text">
                            Чтобы узнать кому продали продукт, сначала добавьте
                            <router-link :to="$i18nHelper.getUrl('customers/add')">{{ $t('customer.title') }}.</router-link>
                        </p>
                    </div>
                    <div v-if="advices[5].isShowAdvice">
                        <p class="text">
                            Добавьте сотрудников компании на странице
                            <router-link :to="$i18nHelper.getUrl('employees/add')">{{ $t('employee.title') }}.</router-link>
                        </p>
                    </div>
                    <div v-if="advices[6].isShowAdvice">
                        <p class="text">
                            Вы можете
                            <router-link :to="$i18nHelper.getUrl('import-excel')">{{ $t('excel.import') }}</router-link>
                            продукты через Excel файл.
                        </p>
                    </div>
                    <div v-if="advices[7].isShowAdvice">
                        <p class="text">
                            Чтобы узнать статистику, перейдите на страницу
                            <router-link :to="$i18nHelper.getUrl('statistics/sale')">{{
                                    $t('statistics.title')
                                }}.
                            </router-link>
                        </p>
                    </div>
                    <div v-if="advices[8].isShowAdvice">
                        <p class="text">
                            Чтобы узнать информации о продаже, прейдите на страницу
                            <router-link :to="$i18nHelper.getUrl('products/transactions')">{{
                                    $t('transactions')
                                }}.
                            </router-link>
                        </p>
                    </div>
                </div>
            </div>

            <div class="card-body" v-if="$i18n.locale === 'uz'">
                <div class="flex justify-between">
                    <div class="card-title text-purple100 text-base">{{ $t('advice') }}</div>
                    <div class="text-gray-500 cursor-pointer" @click="hideAdvice">&#10005;</div>
                </div>

                <div class="text-base text-purple100">
                    <div v-if="advices[0].isShowAdvice">
                        <p class="text">
                            Savdo qilish uchun, avval
                            <router-link :to="$i18nHelper.getUrl('products/add')">{{
                                    $t('product.title')
                                }}
                            </router-link>
                            qo`shing va
                            <router-link :to="$i18nHelper.getUrl('products/0/purchase')">{{
                                    $t('productPurchase.title')
                                }}
                            </router-link>
                            sahifasida mahsulot qo`shing.
                        </p>
                    </div>
                    <div v-if="advices[1].isShowAdvice">
                        <p class="text">
                            Mahsulotni sotish uchun,
                            <router-link :to="$i18nHelper.getUrl('sales/add')">{{ $t('sale.title') }}</router-link>
                            sahifasiga kiring.
                        </p>
                    </div>
                    <div v-if="advices[2].isShowAdvice">
                        <p class="text">
                            Maxsulotlarni qancha miqdorda qolganini bilish uchun,
                            <router-link :to="$i18nHelper.getUrl('warehouses')">{{
                                    $t('warehouse.title')
                                }}
                            </router-link>
                            sahifasiga kiring.
                        </p>
                    </div>
                    <div v-if="advices[3].isShowAdvice">
                        <p class="text">
                            Korxona aktivlarini bilish uchun,
                            <router-link :to="$i18nHelper.getUrl('company')">{{ $t('company.title') }}</router-link>
                            sahifasiga kiring.
                        </p>
                    </div>
                    <div v-if="advices[4].isShowAdvice">
                        <p class="text">
                            Mahsulotni kimga sotganingzni bilish uchun, avval
                            <router-link :to="$i18nHelper.getUrl('customers/add')">{{
                                    $t('customer.title')
                                }}
                            </router-link>
                            qo'shing, keyin sotayotganda mijozni tanlang.
                        </p>
                    </div>
                    <div v-if="advices[5].isShowAdvice">
                        <p class="text">
                            Korxona hodimlarini
                            <router-link :to="$i18nHelper.getUrl('employees/add')">{{
                                    $t('employee.title')
                                }}
                            </router-link>
                            sahifasida kiritishingiz mumkin.
                        </p>
                    </div>
                    <div v-if="advices[6].isShowAdvice">
                        <p class="text">
                            Excel fayli orqali tovarlaringizni
                            <router-link :to="$i18nHelper.getUrl('import-excel')">{{ $t('excel.import') }}</router-link>
                            qilishingiz mumkin.
                        </p>
                    </div>
                    <div v-if="advices[7].isShowAdvice">
                        <p class="text">
                            Statistikani bilish uchun,
                            <router-link :to="$i18nHelper.getUrl('statistics/sale')">{{
                                    $t('statistics.title')
                                }}
                            </router-link>
                            sahifasiga kiring.
                        </p>
                    </div>
                    <div v-if="advices[8].isShowAdvice">
                        <p class="text">
                            Sotuvdagi ma'lumotlarni bilish uchun,
                            <router-link :to="$i18nHelper.getUrl('products/transactions')">{{
                                    $t('transactions')
                                }}
                            </router-link>
                            sahifasiga kiring.
                        </p>
                    </div>
                </div>
            </div>

            <div class="card-body" v-if="$i18n.locale === 'en'">
                <h5 class="card-title">{{ $t('advice') }}</h5>
                <div>
                    <div v-if="advices[0].isShowAdvice">
                        <p class="text">
                            To begin the trade, add product on page
                            <router-link :to="$i18nHelper.getUrl('products/add')">{{ $t('product.title') }}</router-link>
                            and purchase product on
                            <router-link :to="$i18nHelper.getUrl('products/0/purchase')">{{
                                    $t('productPurchase.title')
                                }}
                            </router-link>
                            page.
                        </p>
                    </div>
                    <div v-if="advices[1].isShowAdvice">
                        <p class="text">
                            Go to
                            <router-link :to="$i18nHelper.getUrl('sales/add')">{{ $t('sale.title') }}</router-link>
                            page, in order to sell the product.
                        </p>
                    </div>
                    <div v-if="advices[2].isShowAdvice">
                        <p class="text">
                            Go to
                            <router-link :to="$i18nHelper.getUrl('warehouses')">{{ $t('warehouse.title') }}</router-link>
                            page, in order to know the products balance.
                        </p>
                    </div>
                    <div v-if="advices[3].isShowAdvice">
                        <p class="text">
                            Go to
                            <router-link :to="$i18nHelper.getUrl('company')">{{ $t('company.title') }}</router-link>
                            page, in order to know the company actives.
                        </p>
                    </div>
                    <div v-if="advices[4].isShowAdvice">
                        <p class="text">
                            Add
                            <router-link :to="$i18nHelper.getUrl('customers/add')">{{ $t('customer.title') }}</router-link>
                            to know to whom you sold products, then choose customer during sale process.
                        </p>
                    </div>
                    <div v-if="advices[5].isShowAdvice">
                        <p class="text">
                            Add company employees on
                            <router-link :to="$i18nHelper.getUrl('employees/add')">{{ $t('employee.title') }}</router-link>
                            page.
                        </p>
                    </div>
                    <div v-if="advices[6].isShowAdvice">
                        <p class="text">
                            You may
                            <router-link :to="$i18nHelper.getUrl('import-excel')">{{ $t('excel.import') }}</router-link>
                            your products with Excel file.
                        </p>
                    </div>
                    <div v-if="advices[7].isShowAdvice">
                        <p class="text">
                            Go to
                            <router-link :to="$i18nHelper.getUrl('statistics/sale')">{{
                                    $t('statistics.title')
                                }}
                            </router-link>
                            page, in order to know the statistics.
                        </p>
                    </div>
                    <div v-if="advices[8].isShowAdvice">
                        <p class="text">
                            Go to
                            <router-link :to="$i18nHelper.getUrl('products/transactions')">{{
                                    $t('transactions')
                                }}
                            </router-link>
                            page, in order to know sale information.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-lightGray mt-3 py-2 px-1 rounded">
            <div class="currency-rate">
                <div class="mt-3">
                    <img src="/images/calendar.png" alt="calendar" class="ml-2">
                    <span class="text-gray-500 ml-2 text-xs">{{ dateFormat(new Date()) }}</span>
                    <img src="/images/nbu.png" alt="nbu_logo" class="float-right mr-2 mt-1">
                </div>
                <div class="flex justify-content-between mb-3">
                    <div class="bg-mediumGray h-10 w-20 rounded text-sm flex justify-content-center align-items-center ml-2 mt-3">
                        UZS/USD
                    </div>
                    <div v-if="currency.length" class="text-sm">
                        <div class="mt-3 mr-2 text-gray-600">
                            {{ (getCompanyOrOfficialRate(currency[0].shortName, false, true, 2).rate) }}
                        </div>

                        <div class="text-xs mr-2 float-right">
                             <span
                                 v-if="getCompanyOrOfficialRate(currency[0].shortName, false, true).range > 0"
                                 class="mr-n1 text-green-600"
                             >+</span>
                            <span
                                v-else-if="getCompanyOrOfficialRate(currency[0].shortName, false, true).range < 0"
                                class="mr-n1 text-red-700"
                            >-</span>
                            <span :class="getCompanyOrOfficialRate(currency[0].shortName, false, true).range > 0 ? 'text-green-600' : 'text-red-700'">
                                {{
                                Math.abs(getCompanyOrOfficialRate(currency[0].shortName, false, true).range).toFixed(1)
                                }}</span>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="bg-lightGray mt-3 py-2 px-1 rounded">
            <div class="currency-rate">
                <div class="mt-3">
                    <img src="/images/calendar.png" alt="calendar" class="ml-2">
                    <span class="text-gray-500 ml-2 text-xs">{{ dateFormat(new Date()) }}</span>
                    <img src="/images/nbu.png" alt="nbu_logo" class="float-right mr-2 mt-1">
                </div>
                <div class="flex justify-content-between mb-3">
                    <div class="bg-mediumGray h-10 w-20 rounded text-sm flex justify-content-center align-items-center ml-2 mt-3">
                        UZS/RUB
                    </div>
                    <div v-if="currency.length" class="text-sm">
                        <div class="mt-3 mr-2 text-gray-600">
                            {{ getCompanyOrOfficialRate(currency[1].shortName, false, true, 2).rate }}
                        </div>

                        <div class="text-sm mr-2 float-right">
                              <span
                                  v-if="getCompanyOrOfficialRate(currency[1].shortName, false, true).range > 0"
                                 class="mr-n1 text-green-600"
                              >+</span>
                            <span
                                v-else-if="getCompanyOrOfficialRate(currency[1].shortName, false, true).range < 0"
                                 class="mr-n1 text-red-700"
                            >-</span>
                           <span :class="getCompanyOrOfficialRate(currency[0].shortName, false, true).range > 0 ? 'text-green-600' : 'text-red-700'">
                               {{
                                   Math.abs(getCompanyOrOfficialRate(currency[1].shortName, false, true).range).toFixed(1)
                               }}
                           </span>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";

export default {
    name: "Advice",
    mixins: [dateFormattingMixin, currencyRateMixin, currencyFormatMixin],
    data() {
        return {
            advices: [
                {isShowAdvice: false},
                {isShowAdvice: false},
                {isShowAdvice: false},
                {isShowAdvice: false},
                {isShowAdvice: false},
                {isShowAdvice: false},
                {isShowAdvice: false},
                {isShowAdvice: false},
                {isShowAdvice: false},
            ],
            index: 0
        }
    },
    methods: {
        adviceChanger() {
            if (this.index === 0) {
                this.advices[8].isShowAdvice = false
            }
            if (this.index < this.advices.length) {
                if (this.index >= 1) {
                    this.advices[this.index - 1].isShowAdvice = false
                    this.advices[this.index].isShowAdvice = true
                } else {
                    this.advices[this.index].isShowAdvice = true
                }
                this.index++
            }
            if (this.index === 9) {
                this.index = 0
            }
        },
        hideAdvice() {
            this.$emit('hideAdvice')
        }
    },
    mounted() {
        setTimeout(this.adviceChanger, 1)
        setInterval(this.adviceChanger, 120000)
    }
}
</script>

<style scoped>
    .text {
        margin: 0!important;
    }
</style>
